<script lang="ts">
    import type {Fond} from 'typings/portaro.be.types';
    import {getSutorReportsOptimisationContext} from '../sutor-reports-optimisation-context';
    import KpRecordGrid from 'src/features/record-grid/KpRecordGrid.svelte';

    export let fond: Fond;

    const context = getSutorReportsOptimisationContext();
</script>

<KpRecordGrid injectedSearchManager="{context.optimisationTableSearchContext}"
              fondOrFondId="{fond.id}"/>